/**
 * TrustBadgeRow — pulls /trust-badges and renders them as a horizontal
 * scrolling carousel. If admin hasn't added any badges, it gracefully
 * shows placeholder text-only chips so the area never feels empty.
 */
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../config";const PLACEHOLDERS = [
  { slug: "g2-best-roi",      label: "G2 Best Est. ROI · Winter 2026" },
  { slug: "capterra-49",      label: "Capterra 4.9 ★ · 1,500+ reviews" },
  { slug: "made-in-slovakia", label: "🇸🇰 Made in Slovakia" },
  { slug: "ph-2-of-day",      label: "Product Hunt · #2 Product of the Day" },
  { slug: "software-advice",  label: "Software Advice · Most Recommended 2026" },
];

export function TrustBadgeRow({ language = "en", compact = false }) {
  const [badges, setBadges] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/trust-badges`)
      .then(r => { if (!cancelled) setBadges(r.data?.badges || []); })
      .catch(() => { if (!cancelled) setBadges([]); });
    return () => { cancelled = true; };
  }, []);

  const items = (badges && badges.length > 0) ? badges : PLACEHOLDERS;
  const sk = ["sk", "cs"].includes(language);

  return (
    <div className={`w-full ${compact ? "py-4" : "py-8"}`} data-testid="trust-badge-row">
      <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-[var(--color-text-muted)] mb-4 text-center">
        {sk ? "Ocenené v 2026" : "Awarded in 2026"}
      </p>
      <div className="flex items-center justify-center gap-4 sm:gap-6 flex-wrap">
        {items.map(b => (
          <BadgeItem key={b.slug} badge={b} />
        ))}
      </div>
    </div>
  );
}

function BadgeItem({ badge }) {
  const [imgFailed, setImgFailed] = useState(false);

  if (badge.image_url && !imgFailed) {
    return (
      <a
        href={badge.href || "#"}
        target={badge.href ? "_blank" : undefined}
        rel="noreferrer"
        className="opacity-70 hover:opacity-100 transition-opacity"
        title={badge.label}
        data-testid={`trust-badge-${badge.slug}`}
      >
        <img
          src={badge.image_url}
          alt={badge.label}
          className="h-12 sm:h-16 w-auto object-contain"
          loading="lazy"
          onError={() => setImgFailed(true)}
        />
      </a>
    );
  }
  return (
    <span
      className="px-3 py-1.5 border border-[var(--color-border)] rounded-full text-xs font-medium text-[var(--color-text-muted)] hover:text-white hover:border-white transition-colors"
      data-testid={`trust-badge-${badge.slug}`}
    >
      {badge.label}
    </span>
  );
}

export default TrustBadgeRow;
